import { DealCardsList, DraggableDealCard } from '@crm/pages/deals/ui';

import type { IDealCardData } from '@crm/entities/deal';

type TRenderDealCardsListOptions = {
    activeDealId: string | null;
    hideActiveDealPlaceholder?: boolean;
};

export const renderDealCardsList = (
    id: string,
    group: string,
    deals: IDealCardData[],
    options: TRenderDealCardsListOptions
) => (
    <DealCardsList id={id}>
        {deals.map((obj, index) => (
            <DraggableDealCard
                key={obj.id}
                id={String(obj.id)}
                index={index}
                group={group}
                dealCardData={obj}
                isHiddenPlaceholder={
                    options.hideActiveDealPlaceholder && options.activeDealId === String(obj.id)
                }
                isPlaceholder={options.activeDealId === String(obj.id)}
            />
        ))}
    </DealCardsList>
);
